import * as actionTypes from "./actionTypes";
import { firestore } from "../../firebase";

export const updateConfirmation = (data) => {
    return {
        type: actionTypes.UPDATE_CONFIRMATION,
        data: data
    };
};

export const fetchSignUpStatusSuccess = (status) => {
    return {
        type: actionTypes.FETCH_SIGN_UP_STATUS,
        status: status
    };
};

export const fetchSignUpStatus = () => {
    return dispatch => {
        const signUpsRef = firestore.collection("signups")
            .doc("signups")
            .get();
        signUpsRef.then((doc) => {
            dispatch(fetchSignUpStatusSuccess(doc.data().status));
        });
    }
};

export const updateSignUpStatus = (status) => {
    firestore.collection("signups")
        .doc("signups")
        .update({status: status})
        .catch(error => {
            console.log(error);
        });

    return {
        type: actionTypes.UPDATE_SIGN_UP_STATUS,
        status: status
    }
};
